<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div class="vx-col w-full flex mb-4" id="account-manage-buttons" v-if="user_data.idoperationcategory == 8 && !readOnlyRole">
      <vs-button icon-pack="feather" type="border" icon="icon-edit" class="mr-4"
        :to="{ name: 'app-outlay-edit', params: { userId: $route.params.userId } }">Edit</vs-button>
    </div>

    <div id="user-data" v-if="user_data">
      <div class="vx-row" id="page-user-view">
        <div class="vx-col lg:w-1/3 w-full" v-if="user_data.idoperationcategory == 8">
          <vx-card title="Document" class="mb-base">
            <div ref="container" class="zoom-container" @wheel="onWheel" @mousedown="startDrag" @mousemove="onDrag"
              @mouseup="endDrag" @mouseleave="endDrag">

              <img :src="`https://xylo.codesinn.com/ftp/${user_data.name}`" width="100%" :style="imageStyles">
              <div class="controls">
              </div>
            </div>

          </vx-card>
        </div>
        <div class="vx-col lg:w-2/3 w-full">

          <vx-card>
            <vs-tabs alignment="fixed">
              <vs-tab label="Main" icon-pack="feather" icon="icon-home">
                <table class="mt-8">
                  <tr>
                    <td class="font-semibold">Invoice Number</td>
                    <td>
                      <p v-if="user_data.invoice_no">
                      <div style="display: flex; align-items: center;">
                        {{ user_data.invoice_no }}
                      </div>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Invoice date</td>
                    <td v-if="user_data && user_data.date">{{ format_date(user_data.date, false) }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Due date</td>
                    <td>{{ format_date(user_data.date_delivery_desired, false) }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Internal ID</td>
                    <td>
                      <div style="display: flex; align-items: center;">
                        YD{{ user_data.id }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">eFactura id</td>
                    <td>DESC. {{ user_data.efactura_iddescarcare }} / INC. {{ user_data.efactura_idincarcare }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Create/Update</td>
                    <td>{{ format_date(user_data.createdAt, true) }} / {{ format_date(user_data.updatedAt, true) }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Detalii plata</td>
                    <td>
                      <div style="display: flex; align-items: center;">
                        {{ user_data.invoice_no }} YD{{ user_data.id }}<vs-button style="margin-left: 10px;"
                          @click="copyToClipboard(user_data.invoice_no + ' YD' + user_data.id)" icon-pack="feather"
                          icon="icon-copy"></vs-button>
                      </div>
                    </td>
                  </tr>

                  <!--<tr>
                    <td class="font-semibold">Payment Status</td>
                    <td class="font-semibold"><vs-switch color="success" v-model="user_data.isexppaid">
                            <span slot="on">Is paid</span>
                            <span slot="off">Not Paid</span>
                          </vs-switch></td>
                  </tr>-->
                  <tr v-if="user_data && user_data.people && user_data.people[0].bank_account">
                    <td class="font-semibold">Account Number</td>
                    <td>
                      <div style="display: flex; align-items: center;">
                        <h4>{{ user_data.people[0].bank_account }}</h4>
                        <vs-button style="margin-left: 10px;" @click="copyToClipboard(user_data.people[0].bank_account)"
                          icon-pack="feather" icon="icon-copy"></vs-button>
                      </div>
                    </td>
                  </tr>
                </table>
                <vs-alert v-if="user_data.mail_bottom_payment" class="mt-8" color="warning" title="Payment"
                  active="true">{{ user_data.mail_bottom_payment }}</vs-alert>
                <vs-alert class="mt-8" color="success" title="Total" active="true">Total Excl. Tax : {{ thesum
                  }}<br />Total Incl. Tax : {{ thesumtt }}</vs-alert>

              </vs-tab>
              <vs-tab label="Supplier" icon-pack="feather" icon="icon-user">
                <table class="mt-8">
                  <tr>
                    <td class="font-semibold">Name</td>
                    <td v-if="user_data.people">
                      <span>
                        <router-link :to="{ path: '/person/' + user_data.people[0].id }"
                          class="text-inherit underline">{{
                            user_data.people[0].company_name }}</router-link>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="user_data.people">
                    <td class="font-semibold">VAT</td>
                    <td>{{ user_data.people[0].vat_number }}</td>
                  </tr>
                  <tr v-if="user_data.people">
                    <td class="font-semibold">Email</td>
                    <td>{{ user_data.people[0].email }}</td>
                  </tr>
                  <tr v-if="user_data.people">
                    <td class="font-semibold">Phone</td>
                    <td>{{ user_data.people[0].phone }}</td>
                  </tr>
                  <tr v-if="user_data.people && user_data.people[0].addresses">
                    <td class="font-semibold">Address Manual</td>
                    <td>
                  <tr v-if="user_data.people" v-for="(val, id) in user_data.people[0].addresses" :key="id">
                    <vs-td>
                      <u>{{ val.addresscategory.name_en }}</u>
                      <p v-if="val.place.province">
                        {{ val.street }} {{ val.number }},
                        <br />
                        {{ val.place.postal_code }} {{ val.place.place_name }} ({{ val.place.province }}),
                        <br />
                        {{ val.place.region }}, {{ val.place.country.name_en }}
                      </p>

                      <p v-else>
                        {{ val.street }} {{ val.number }},
                        <br />
                        {{ val.place.postal_code }} {{ val.place.place_name }} ({{ val.place.region }}),
                        <br />
                        {{ val.place.country.name_en }}
                      </p>
                    </vs-td>
                  </tr>
                  </td>
                  </tr>
                  <tr v-if="user_data.people && user_data.people[0].billing_address_str">
                    <td class="font-semibold">Address Auto</td>
                    <td>
                  <tr>
                    <vs-td>
                      <p v-if="user_data.people && user_data.people[0].billing_address_str">
                        {{ user_data.people[0].billing_address_str }}
                      </p>
                    </vs-td>
                  </tr>
                  </td>
                  </tr>
                  <tr v-if="user_data.people && user_data.people[0].country_code_str">
                    <td class="font-semibold">Country</td>
                    <td>
                  <tr>
                    <vs-td>
                      <p v-if="user_data.people && user_data.people[0].country_code_str">
                        {{ user_data.people[0].country_code_str }}
                      </p>
                    </vs-td>
                  </tr>
                  </td>
                  </tr>
                </table>
              </vs-tab>
              <vs-tab label="Products/Services" icon-pack="feather" icon="icon-box">
                <div id="data-list-list-view" class="data-list-container">
                  <vs-table ref="table" :data="products">
                    <template slot="thead">
                      <vs-th>Name</vs-th>
                      <vs-th>Account</vs-th>
                      <vs-th sort-key="username">Quantity</vs-th>
                      <vs-th>UoM</vs-th>
                      <vs-th>Unit Excl. Tax</vs-th>
                      <vs-th>Total Excl. Tax</vs-th>
                      <vs-th>VAT</vs-th>
                      <vs-th>Total Incl. Tax</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>{{ tr.product }}</vs-td>
                          <vs-td v-if="tr.cont">{{ tr.cont }}</vs-td>
                          <vs-td v-else>-</vs-td>
                          <vs-td>{{ parseFloat(tr.quantity).toFixed(2) }}</vs-td>
                          <vs-td>{{ tr.uom }}</vs-td>
                          <vs-td>{{ parseFloat(tr.unit_price_htva).toFixed(2) }} {{ tr.currency }}</vs-td>
                          <vs-td>{{ parseFloat(tr.quantity * tr.unit_price_htva).toFixed(2) }} {{ tr.currency }}</vs-td>
                          <vs-td>{{ tr.tva_pct }}%</vs-td>
                          <vs-td>{{ parseFloat((tr.quantity * tr.unit_price_htva) * (1 + tr.tva_pct / 100)).toFixed(2)
                            }} {{
                              tr.currency }}</vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>
                <vs-alert color="success" title="Total" active="true">Total Excl. Tax : {{ thesum }}<br />Total Incl.
                  Tax
                  : {{ thesumtt }}</vs-alert>
              </vs-tab>
              <vs-tab v-if="user_data.idoperationcategory == 8" label="AI" icon-pack="feather" icon="icon-cpu">
                <div class="mb-16">
                  <u><b>Step 1 : XyloAI</b></u><br />
                  <div v-html="formatData(user_data.result_ai_1)"></div>
                </div>
                <div>
                  <u><b>Step 2 : OpenAI</b></u><br />
                  <div v-html="formatData(user_data.result_ai_2)"></div>
                </div>
              </vs-tab>
            </vs-tabs>
          </vx-card>

        </div>

        <div class="vx-col lg:w-1/3 w-full">
          <vx-card>
            <h4>Actions</h4>


            <vs-button class="ml-auto mt-2 w-full mb-8" @click="downloadEfactura()" icon-pack="feather"
              icon="icon-file-text">Download eFactura (SPV)</vs-button>
            <div class="vx-row" id="page-user-view">
              <div class="vx-col lg:w-2/3 w-full">
                <h6>Budget Category</h6>
                <!--<vs-select class="w-full" v-model="localBudgetCategory" :reduce="(item) => item">
                  <template v-for="(item, index) in databudgetcategoryGrouped">
                    <vs-select-group :key="index" :title="item.title" v-if="item.group">
                      <vs-select-item v-for="(subItem, subIndex) in item.group" :key="subIndex" :value="subItem"
                        :text="subItem.text" />
                    </vs-select-group>
                  </template>
                </vs-select>-->

                <select v-model="localBudgetCategory" class="w-full mt-1">
                  <optgroup v-for="(group, index) in databudgetcategoryGrouped" :key="index" :label="group.title">
                    <option v-for="(subItem, subIndex) in group.group" :key="subIndex" :value="subItem">
                      {{ subItem.text }}
                    </option>
                  </optgroup>
                </select>
              </div>

              <div class="vx-col lg:w-1/3 w-full">
                <vs-button class="ml-auto w-full mt-5" color="warning" @click="clearSelection">Clear</vs-button>
              </div>
            </div>

            <h6 class="mt-8">Force Payment Status</h6>

            <vs-switch class="mt-2 w-1/2" color="success" v-model="user_data.isexppaid">
              <span slot="on">Force paid</span>
              <span slot="off">Not Paid</span>
            </vs-switch>
            <vs-button class="ml-auto mt-16 w-full" color="success" @click="save_changes">Save Changes</vs-button>
          </vx-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import "jspdf-autotable";
import moment from "moment";
import { AmiriRegular } from "@/assets/fonts/Amiri-Regular-normal.js";
import axios from "@/axios.js";
import vSelect from 'vue-select'
import { isAccountantOnly } from '@/helpers/roleAccess.js'


export default {
  components: {
    vSelect,
  },
  data() {
    return {
      localBudgetCategory: null, // Déclarez la propriété ici
      readOnlyRole: isAccountantOnly(), // comptable : pas de bouton Edit

      scale: 1,
      minScale: 0.5,
      maxScale: 3,
      dragging: false,
      startX: 0,
      startY: 0,
      translateX: 0,
      translateY: 0,

      user_not_found: false,
      productlist: [],
      thesum: 0,
      thesumtt: 0,
      databudgetcategoryGrouped: [
        {
          title: 'Teiu',
          group: [
            { text: '1. Consumables', value: 1 },
            { text: '2. Infrastructure Construction', value: 2 },
            { text: '3. Machine Acquisition', value: 3 },
            { text: '4. Machine Repair', value: 4 },
            { text: '21. Equipment Protection', value: 21 },
          ]
        },
        {
          title: 'Forest',
          group: [
            { text: '5. Consumables', value: 5 },
            { text: '6. Machine Acquisition', value: 6 },
            { text: '7. Machine Repair', value: 7 },
            { text: '8. Services (Harvesting, Roads, etc.)', value: 8 },
          ]
        },
        {
          title: 'General Services',
          group: [
            { text: '9. HR, Marketing, Accounting, IT, Legal, Freelances, Penalties', value: 9 },
            { text: '16. Salaries & Independent', value: 16 },
            { text: '19. Bonus (Salaries)', value: 19 },
            { text: '11. Broker', value: 11 },
            { text: '99. Meal Tickets', value: 99 },
          ]
        },
        {
          title: 'Energy',
          group: [
            { text: '10. Fuel, Electricity & Oil', value: 10 },
          ]
        },
        {
          title: 'Transport',
          group: [
            { text: '12. Client Transport', value: 12 },
            { text: '13. Teiu Transport - Raw Materials', value: 13 },
            { text: '17. Teiu Transport - Finished Products', value: 17 },
          ]
        },
        {
          title: 'Raw Material',
          group: [
            { text: '14. Wood on Stand', value: 14 },
            { text: '15. Round Wood from Suppliers', value: 15 },
            { text: '18. Product from Reception', value: 18 },
          ]
        },
        {
          title: 'Other',
          group: [
            { text: '20. Travel, Duster, Touran', value: 20 },
          ]
        }
      ],
      user_data: {
        budgetcategory: null // Initialisez avec une valeur par défaut ou null
      }
    };
  },
  /*
  watch: {
  'user_data.isexppaid': function(newValue, oldValue) {
   
  }
},*/
  computed: {

    imageStyles() {
      return {
        transform: `scale(${this.scale}) translate(${this.translateX / 1.5}px, ${this.translateY / 1.5}px)`,
        transition: 'transform 0s',
        cursor: this.dragging ? 'grabbing' : 'grab'
      };
    },

    userAddress() {
      let str = "";
      for (const field in this.user_data.address) {
        str += `${field} `;
      }
      return str;
    },
    products() {
      return this.$store.state.operationList.expense.expenselines;
    },
  },
  methods:
  {
    clearSelection() {
      this.localBudgetCategory = null;
    },
    downloadEfactura() {
      let obj = {
        id_solicitare: this.user_data.efactura_iddescarcare,
        id: this.user_data.efactura_idincarcare
      };
      this.$store
        .dispatch("BankList/downloadEfactura", obj).then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.error(err);
        });

    },
    // Catégorie budget + payé : route dédiée qui n'écrit que ces deux champs
    // (seule écriture ouverte à la comptable). On attend la réponse : avant,
    // « Updated! » s'affichait même quand l'enregistrement échouait.
    save_changes() {
      if (!this.user_data) return;
      this.$vs.loading();
      this.$store
        .dispatch("operationList/classifyExpense", {
          id: this.$route.params.userId,
          budgetcategory: this.localBudgetCategory ? this.localBudgetCategory.value : null,
          isexppaid: !!this.user_data.isexppaid,
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Updated!",
            text: "successfully updated"
          });
          this.$router.push({ path: "/efacturalist-ing" });
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: "Not saved",
            text: (err && err.response && err.response.data && err.response.data.message) || "The changes could not be saved.",
          });
        })
        .finally(() => this.$vs.loading.close());
    },
    copyToClipboard(textToCopy) {
      const el = document.createElement('textarea');
      el.value = textToCopy;  // Utilisation de la variable textToCopy directement
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$vs.notify({
        title: "Copy",
        text: "Copied to Clipboard",
        iconPack: "feather",
        icon: "icon-clipboard",
        color: "success",
        position: "bottom-right",
        time: 4000,
      });
    },

    formatData(data) {
      if (data) return data.replace(/\n\s*\n/g, '\n').replace(/\n+/g, '<br/>');
    },
    zoomIn() {
      if (this.scale < this.maxScale) {
        this.scale *= 1.05;
      }
    },
    zoomOut() {
      if (this.scale > this.minScale) {
        this.scale /= 1.05;
      }
    },
    onWheel(event) {
      event.preventDefault();

      const scaleAmount = 0.1; // Facteur de zoom
      const containerRect = this.$refs.container.getBoundingClientRect();

      // Position du curseur par rapport au conteneur
      const cursorX = event.clientX - containerRect.left;
      const cursorY = event.clientY - containerRect.top;

      // Position du curseur par rapport à l'image
      const imageX = cursorX - this.translateX;
      const imageY = cursorY - this.translateY;

      // Calcul du nouveau facteur de zoom
      const newScale = this.scale * (event.deltaY < 0 ? 1 + scaleAmount : 1 - scaleAmount);

      // Restreindre le zoom entre minScale et maxScale
      this.scale = Math.min(Math.max(newScale, this.minScale), this.maxScale);

      // Ajustement de la translation pour centrer le zoom sur la position du curseur
      if (this.scale !== this.minScale && this.scale !== this.maxScale) {
        this.translateX = imageX - imageX * newScale / this.scale + cursorX - imageX;
        this.translateY = imageY - imageY * newScale / this.scale + cursorY - imageY;
      }
    },
    startDrag(event) {
      event.preventDefault();
      this.dragging = true;
      this.startX = event.clientX - this.translateX;
      this.startY = event.clientY - this.translateY;
    },
    onDrag(event) {
      event.preventDefault();
      if (this.dragging) {
        this.translateX = event.clientX - this.startX;
        this.translateY = event.clientY - this.startY;
      }
    },
    endDrag() {
      event.preventDefault();
      this.dragging = false;
    },


    calculateSumHT() {
      let sum = 0;
      let sumtt = 0;
      this.products.forEach(e => {
        sum = sum + ((e.unit_price_htva) * (e.quantity))
        sumtt = sumtt + ((e.quantity * e.unit_price_htva) * (1 + (e.tva_pct) / 100))
      });
      this.thesum = sum.toFixed(2) + " " + this.products[0].currency
      this.thesumtt = sumtt.toFixed(2) + " " + this.products[0].currency
    },
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    moment: function () {
      return moment();
    },
    ViewCompany() {
      window.location.replace("/person/" + this.user_data.Company.id);
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    }
  },
  created() {
    this.$vs.loading();
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }

    const userId = this.$route.params.userId;
    this.$store
      .dispatch("operationList/fetchExpense", userId)
      .then(res => {
        this.user_data = res.data;

        // Vérifiez que les données nécessaires existent
        if (this.databudgetcategoryGrouped.length > 0) {
          const matchingCategory = this.databudgetcategoryGrouped
            .flatMap(group => group.group || [])
            .find(item => item.value === this.user_data.budgetcategory);

          this.localBudgetCategory = matchingCategory || null;
        }

        this.calculateSumHT();
        console.log("databudgetcategoryGrouped:", this.databudgetcategoryGrouped);
        console.log("Initial localBudgetCategory:", this.localBudgetCategory);
        this.$vs.loading.close();
      })
      .catch(err => {
        console.error("Error fetching user data:", err);
        this.user_not_found = true; // Activez l'alerte si l'utilisateur est introuvable
        this.$vs.loading.close();
      });
  },
};
</script>

<style lang="scss">
select {
  width: 100%;
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  /* Couleur de la bordure */
  border-radius: 0.375rem;
  /* Coins arrondis */
  background-color: #f9fafb;
  /* Couleur de fond */
  font-size: 1rem;
  color: #374151;
  /* Couleur du texte */
  appearance: none;
  /* Supprime la flèche par défaut */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Ombre légère */
  transition: all 0.2s ease-in-out;
}

select:hover {
  border-color: #9ca3af;
  /* Changement de bordure au survol */
}

select:focus {
  outline: none;
  border-color: #2563eb;
  /* Couleur de bordure au focus */
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.3);
  /* Ombre autour */
}

option {
  font-size: 1rem;
  color: #374151;
  padding: 0.5rem;
}

optgroup {
  font-weight: bold;
  color: #111827;
  /* Couleur du titre des groupes */
  padding: 0.5rem 1rem;
}

.zoom-container {
  overflow: hidden;
  position: relative;
}

.zoom-container img {
  user-select: none;
  /* Empêche la sélection de l'image lors du drag */
}

.controls {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.controls button {
  font-size: 20px;
  margin: 5px;
}

#avatar-col {
  width: 10rem;
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}

/*
.vs-chip-success {
  background: rgba(var(--vs-success), 0.15);
  color: rgba(var(--vs-success), 1) !important;
  font-weight: 500;
}
.vs-chip-warning {
  background: rgba(var(--vs-warning), 0.15);
  color: rgba(var(--vs-warning), 1) !important;
  font-weight: 500;
}
.vs-chip-danger {
  background: rgba(var(--vs-danger), 0.15);
  color: rgba(var(--vs-danger), 1) !important;
  font-weight: 500;
}*/
</style>
